import { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model.ts"
import { useKnownBusinessEntitiesContactsStore } from "@/store/known-business-entities-contacts.store.ts"
import { storeToRefs } from "pinia"
import { helpers } from "@vuelidate/validators"

function KBECEmailIsUnique(email: string | undefined, model: KnownBusinessEntityContact): boolean {
  const knownBusinessEntityContactStore = useKnownBusinessEntitiesContactsStore()
  const { activeKnownBusinessEntitiesContacts } = storeToRefs(knownBusinessEntityContactStore)

  return !activeKnownBusinessEntitiesContacts.value.some((kbec) => {
    return !!kbec.email && kbec.email.toLowerCase() === email?.toLowerCase() && kbec.id !== model.id
  })
}

export const KBECEmailIsUniqueValidator = helpers.withMessage(
  "Er bestaat al een persoon bij dit bedrijf met dit e-mailadres",
  KBECEmailIsUnique
)

function personPhoneNumberIsUnique(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  phoneNumber: string,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  model: KnownBusinessEntityContact
): boolean {
  return true // Disabled until further notice
  // const knownBusinessEntityContactStore = useKnownBusinessEntitiesContactsStore()
  // const { activeKnownBusinessEntitiesContacts } = storeToRefs(knownBusinessEntityContactStore)
  //
  // return !activeKnownBusinessEntitiesContacts.value.some((kbec) => {
  //   return kbec.phoneNumber && kbec.phoneNumber === phoneNumber && kbec.person.id !== model.person.id
  // })
}

export const personPhoneNumberIsUniqueValidator = helpers.withMessage(
  "Er bestaat al een persoon met dit telefoonnummer",
  personPhoneNumberIsUnique
)
